import "./App.css";
import Videos from "./Videos";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Video Recommendation</h1>
      </header>
      <div>
        <Videos />
      </div>
    </div>
  );
}

export default App;
